import { render, staticRenderFns } from "./askQues.vue?vue&type=template&id=05759e4f&scoped=true"
import script from "./askQues.vue?vue&type=script&lang=js"
export * from "./askQues.vue?vue&type=script&lang=js"
import style0 from "./askQues.vue?vue&type=style&index=0&id=05759e4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05759e4f",
  null
  
)

export default component.exports